import "./ExhibitionItem.css"

import {useState} from "react";

import {useDashboardLocale} from "../../context/dashboard_locale";
import {capitalize} from "../../utils/strings";
import { defaultDateFormat } from "../../utils/date";

import RemoveButton from "../removeButton/RemoveButton";

export default function ExhibitionItem(props) {
    const [showDetails, setShowDetails] = useState(false);
    const {strings} = useDashboardLocale();
    const id = props.id;
    const title = props.title;
    const createdAt = props.createdAt;
    const onEditItemClick = props.onEditItemClick;
    const onViewItemClick = props.onViewItemClick;
    const onQrItemClick = props.onQrItemClick;
    const onDeleteClick = props.onDeleteClick;
    const trackFileStatistics = props.trackFileStatistics ?? [];
    let detailsButtonClasses = ["exhibition-item-arrow"];
    let detailsStatisticContainerClassNames = [];
    if (showDetails) {
      detailsButtonClasses.push("exhibition-item-up");
      detailsStatisticContainerClassNames.push("flex justify-start");
    } else {
      detailsButtonClasses.push("exhibition-item-down");
      detailsStatisticContainerClassNames.push("hidden");
    }
    const detailsStatisticJSXs = (
      <table className="exhibition-item-table table-auto">
        <thead>
          <tr>
            <th className="text-left">{capitalize(strings["title"])}</th>
            <th className="text-center">{capitalize(strings["count"])}</th>
            <th className="text-left">{capitalize(strings["last_visited"])}</th>
          </tr>
        </thead>
        <tbody>
          { 
            trackFileStatistics.map((trackFileStatistic, idx) => {
              let title = (trackFileStatistic.title ?? "").trim();
              if (!title.length) {
                title = capitalize(strings["empty_field"]);
              }
              let count = `${trackFileStatistic.count}`;
              if (!trackFileStatistic.count) {
                count = '-';
              }
              let date = '-';
              if (trackFileStatistic.date && trackFileStatistic.count) {
                date = defaultDateFormat(trackFileStatistic.date)
              }
              return(
                <tr key={idx}>
                  <td className="text-left">{title}</td>
                  <td className="font-bold text-center">{count}</td>
                  <td className="text-left">{date}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    );

    function toggleDetails(e) {
      setShowDetails(!showDetails);
    }

    return (<li key={id}>
        <div className="flex flex-col bg-gray-200 p-4 rounded-lg gap-2">
          <div className="w-full flex items-center justify-between">
            <div className="text-left flex items-center gap-3">
                <div>
                    <p className="text-lg font-semibold"><span>{strings["id"]}: </span><span>{id}</span></p>
                    <p className="text-base font-semibold"><span>{title}</span></p>
                    <p className="text-gray-500 text-sm"><span>{capitalize(strings["updated_at"])}: </span><span>{createdAt}</span></p>
                </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                  onClick={toggleDetails}
                  className="bg-primary-500 text-white px-3 py-1 rounded-md hover:bg-primary-700"
              >
                  <i className={detailsButtonClasses.join(' ')}></i>
              </button>
                <button
                    onClick={() => onViewItemClick(id)}
                    className="bg-primary-500 text-white px-3 py-1 rounded-md hover:bg-primary-700"
                >
                    {capitalize(strings["view"])}
                </button>
                <button
                    onClick={() => onQrItemClick(id)}
                    className="bg-primary-500 text-white px-3 py-1 rounded-md hover:bg-primary-700"
                >
                    {strings["qr_code"].toUpperCase()}
                </button>
                <button
                    onClick={onEditItemClick.bind(null, id)}
                    className="bg-primary-500 text-white px-3 py-1 rounded-md hover:bg-primary-700"
                >
                    {capitalize(strings["edit"])}
                </button>
                <button
                    onClick={onDeleteClick.bind(null, id)}
                    className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-700"
                >
                    {capitalize(strings["delete"])}
                </button>
            </div>
          </div>
          <div className={detailsStatisticContainerClassNames.join(' ')}>
            {detailsStatisticJSXs}
          </div>
        </div>
    </li>)
}